module.exports = __webpack_public_path__ + "images/gbi_logo_on_dark_da3bd8b.svg";